<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-profile-line me-1 text-primary"></i>KYC
                </h5>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="200" >Document Type</th>
                  <th scope="col" width="300"class="text-center">Document File</th>
                  <th scope="col" width="150">Status</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let kyc of kycs | search : 'name' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{kyc.type}}</td>
                  <td class="text-center">
                    <ng-container *ngIf="kyc.documentFileUrl; else defaultAvatar">
                      <ng-container *ngIf="kyc.documentFileUrl.endsWith('.pdf'); else imagePreview" ngbTooltip="View pdf">
                        <i class="ri-file-pdf-line text-danger" style="font-size: 25px; cursor: pointer;" (click)="upsertkyc(kyc)"></i>
                      </ng-container>
                      <ng-template #imagePreview>
                        <img [src]="kyc.documentFileUrl" alt="Document Image" width="30" height="25" (click)="upsertkyc(kyc)" style="cursor: pointer;" ngbTooltip="View" />
                      </ng-template>
                    </ng-container>
                    <ng-template #defaultAvatar>
                      <img src="assets/images/no_media.png" alt="Default Avatar" width="30" height="25" />
                    </ng-template>
                  </td>
                  <td>
                    <span class="badge rounded-pill bg-{{ kyc.status === 'COMPLETED' ? 'success' : 'danger' }}">
                      {{ kyc.status }}
                    </span>
                  </td>
                  <td class="actions">
                    <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event, kyc)" />
                    <i class="ri-upload-2-line alert-primary"
                      [ngClass]="{'no-event': kyc?.isDeleteInProgress, 'not-allowed': !privilege.canEdit}"
                      [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): dossier.kyc.edit' : 'Upload File'"
                      (click)="fileInput.click()">
                    </i>
                    <div *ngIf="kyc?.isDeleteInProgress" role="status"
                      class="spinner-border spinner-border-sm text-danger">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>

                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="6">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="holidays && holidays.length < 1; else noSearchResults">
                      <td colspan="6">No kyc were found for the selected year.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="6" *ngIf="searchKeyword && (holidays | search : 'name' : searchKeyword).length == 0">
                        No kyc were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>